export { default } from './Boleto25Banner';
